// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1z7Ht","tab":"Tabs_tab__1oRl2","tabActive":"Tabs_tabActive__2mrpL"};